"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageDetection = languageDetection;
const intl_localematcher_1 = require("@formatjs/intl-localematcher");
const negotiator_1 = __importDefault(require("negotiator"));
const server_1 = require("next/server");
const configs_1 = require("../configs");
const helpers_1 = require("../helpers");
const LOCALE_COOKIE_NAME = "NEXT_LOCALE";
const getPrefferedLocale = (req, activeLocales, defaultLocale, cookieLocale) => {
    if (req.nextUrl.locale) {
        const isSupported = activeLocales.includes(req.nextUrl.locale);
        if (isSupported) {
            return req.nextUrl.locale === defaultLocale ? defaultLocale : req.nextUrl.locale;
        }
    }
    if (cookieLocale) {
        return cookieLocale;
    }
    const negotiatorHeaders = {};
    req.headers.forEach((value, key) => (negotiatorHeaders[key] = value));
    const preferedlanguages = new negotiator_1.default({ headers: negotiatorHeaders }).languages(activeLocales);
    const locale = (0, intl_localematcher_1.match)(preferedlanguages, activeLocales, defaultLocale);
    return locale;
};
function setLocaleCookie(response, locale) {
    response.cookies.set(LOCALE_COOKIE_NAME, locale, {
        expires: new Date(Date.now() + helpers_1.ONE_MONTH_IN_MS),
        sameSite: "none",
        secure: true,
        httpOnly: true,
    });
}
function setURLLocale(req, locale, defaultLocale) {
    const nextUrl = req.nextUrl.clone();
    nextUrl.locale = locale === defaultLocale ? configs_1.DEFAULT_ROOT_LOCALE : locale;
    return nextUrl;
}
function languageDetection(req) {
    const COMMON_SITE_CONFIGS = (0, configs_1.getEnvironmentVariable)("COMMON_SITE_CONFIGS");
    const activeLocales = COMMON_SITE_CONFIGS.activeLocales;
    const defaultLocale = COMMON_SITE_CONFIGS.defaultLocale;
    const cookieLocale = req.cookies.get(LOCALE_COOKIE_NAME)?.value;
    const prefferedLocale = getPrefferedLocale(req, activeLocales, defaultLocale, cookieLocale);
    const firstTimeVisitor = !cookieLocale;
    const locale = req.nextUrl.locale;
    if (locale === configs_1.DEFAULT_ROOT_LOCALE && prefferedLocale === defaultLocale) {
        const response = server_1.NextResponse.next();
        setLocaleCookie(response, prefferedLocale);
        return response;
    }
    if (firstTimeVisitor) {
        const nextUrl = setURLLocale(req, prefferedLocale, defaultLocale);
        if (nextUrl.href === req.nextUrl.href) {
            const response = server_1.NextResponse.next();
            setLocaleCookie(response, prefferedLocale);
            return response;
        }
        else {
            const response = server_1.NextResponse.redirect(nextUrl);
            setLocaleCookie(response, prefferedLocale);
            return response;
        }
    }
    else {
        if (locale !== prefferedLocale) {
            const nextUrl = setURLLocale(req, prefferedLocale, defaultLocale);
            const response = server_1.NextResponse.redirect(nextUrl);
            setLocaleCookie(response, prefferedLocale);
            return response;
        }
        if (locale !== cookieLocale) {
            const response = server_1.NextResponse.next();
            setLocaleCookie(response, prefferedLocale);
            return response;
        }
    }
}
//# sourceMappingURL=languageDetection.js.map